import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../../tailwind.config';

export const CrmActivityCallIcon: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['white'], background = theme.colors['teal-100'] }) => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill={background}/>
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke={background}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M23.6917 22.4417C24.625 22.75 25.625 22.9167 26.6667 22.9167C27.125 22.9167 27.5 23.2917 27.5 23.75V26.6667C27.5 27.125 27.125 27.5 26.6667 27.5C18.8417 27.5 12.5 21.1583 12.5 13.3333C12.5 12.875 12.875 12.5 13.3333 12.5H16.25C16.7083 12.5 17.0833 12.875 17.0833 13.3333C17.0833 14.375 17.25 15.375 17.5583 16.3083C17.65 16.6 17.5833 16.925 17.35 17.1417L15.5167 18.9833C16.7167 21.35 18.65 23.275 21.0083 24.475L22.8417 22.6417C23.075 22.4167 23.4 22.35 23.6917 22.4417ZM25 15H27.5V16.6667H25V19.1667H23.3333V16.6667H20.8333V15H23.3333V12.5H25V15Z" fill={fill}/>
    </svg>
  )
);
